import { computed } from 'vue'
import { useAppStore } from '/@/store/modules/app'
import { ThemeEnum } from '/@/enums/appEnum'

export const useTheme = () => {
  const appStore = useAppStore()
  const isDarkMode = computed(() => appStore.getDarkMode === 'dark')

  const toggleTheme = () => {
    const newMode = isDarkMode.value ? ThemeEnum.LIGHT : ThemeEnum.DARK
    appStore.setDarkMode(newMode)
  }

  return {
    isDarkMode,
    toggleTheme,
  }
}
